export const GUEST_USER_LIST_SUCCESS = "GUEST_USER_LIST_SUCCESS";
export const GUEST_USER_LOGIN_SUCCESS = "GUEST_USER_LOGIN_SUCCESS";

export const GUEST_USER_LOADER_VISIBILITY = "GUEST_USER_LOADER_VISIBILITY";
